import * as types from './constants';

// Delete Code Bulk
export const deleteCodeBulkRequest = data => (
  { type: types.DELETE_CODE_BULK_REQUEST, payload: data }
);

export const deleteCodeBulkDone = data => (
  { type: types.DELETE_CODE_BULK_DONE, payload: data }
);

export const deleteCodeBulkFailed = errors => (
  { type: types.DELETE_CODE_BULK_FAILED, payload: errors }
);